/// <amd-module name="Dashboards/RateLimiter/IThrottleHighResourceUsage" />

/** Information provided by a listener implementation to describe an occurrence of high resource usage. */
export interface HighResourceUsageInformation {
    /** Best effort information about what endpoint was reporting the high usage, can vary by provider. */
    originatingUri: string;

    /**
     * Identifies the listener implementation passing this information.
     */
    listenerImplementationName: string;
}

/** Contract for a service which reacts to notifications of high resource usage. */
export interface IThrottleOnHighResourceUsage {
    /**
     * Notify a throttling service to recommend that the user be throttled due to high resource usage.
     */
    flagAsThrottled: (usageInformation: HighResourceUsageInformation) => void;
}
